import { isNumber } from "util";
import { parseTimeFromSeconds } from "../../helpers";
export var mapGameTime = function (x) {
    x.gameTime = getGameTime(x);
    return x;
};
var getGameTime = function (x) {
    if (!x.liveGameState || !isNumber(x.liveGameState.gameTime)) {
        return "";
    }
    return isEventInHalfTime(x.liveGameState) ? "" : parseTimeFromSeconds(x.liveGameState.gameTime);
};
var isEventInHalfTime = function (liveGameState) {
    return liveGameState.gamePart && liveGameState
        .gamePart
        .startsWith("Break");
};
//# sourceMappingURL=mapGameTime.js.map